export const isDecember = (): boolean => new Date().getMonth() === 11
